import React from 'react';
import { ArrowLeft, SearchX } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => (
  <main className="grid min-h-[80vh] place-items-center px-4 pb-20 pt-28">
    <div className="max-w-xl text-center">
      <div className="mx-auto grid h-20 w-20 place-items-center rounded-3xl border border-white/[0.08] bg-white/[0.035] text-blue-300">
        <SearchX className="h-9 w-9" />
      </div>
      <p className="mt-7 text-sm font-bold uppercase tracking-[0.22em] text-blue-400">Błąd 404</p>
      <h1 className="mt-3 text-4xl font-black tracking-tight text-white sm:text-5xl">Nie znaleziono tej strony.</h1>
      <p className="mt-4 leading-7 text-slate-400">Adres mógł się zmienić albo zawiera literówkę. Wróć do strony głównej i wybierz właściwą sekcję.</p>
      <Link to="/" className="button-primary mt-8">
        <ArrowLeft className="h-4 w-4" /> Wróć do strony głównej
      </Link>
    </div>
  </main>
);

export default NotFound;
